import { Row, Col } from "antd";
import HeroDivider from "/app/src/components/HeroUi/Divider";
import "./_status.scss";
import { useTranslation } from "react-i18next";
import StatusHook from "./statusHook";
import { IconToolTip } from "/app/src/components/icons/IconBuilder";
import Box from "/app/src/components/generic/components/box";

/**
 * Component for displaying performance
 * @returns JSX.Element
 *
 */
export default function Performance() {
  const { t } = useTranslation();
  const {
    apiCallsByMonth,
    workflowsCount,
    snapshotCount,
    reportCount,
    fileCount,
  } = StatusHook();

  return (
    <Box>
      <Row>
        <Col span={12}>
          <div className="title flex items-center">
            {t("translation:api_calls_month")}
            <IconToolTip
              content={t("translation:api_calls_30")}
              className="ml-1"
            />
          </div>
        </Col>
        <Col span={12}>
          <div className="title">{apiCallsByMonth}</div>
        </Col>
      </Row>
      <Col span={24}>
        <HeroDivider className="my-6" />
      </Col>
      <Row>
        <Col span={12}>
          <div className="title flex items-center">
            {t("translation:files_this_month")}
            <IconToolTip
              content={t("translation:files_last_30")}
              className="ml-1"
            />
          </div>
        </Col>
        <Col span={12}>
          <div className="title">{fileCount}</div>
        </Col>
      </Row>
      <Col span={24}>
        <HeroDivider className="my-6" />
      </Col>
      <Row>
        <Col span={12}>
          <div className="title flex items-center">
            {t("translation:workflows")}
            <IconToolTip
              content={t("translation:active_workflows")}
              className="ml-1"
            />
          </div>
        </Col>
        <Col span={12}>
          <div className="title">{workflowsCount}</div>
        </Col>
      </Row>
      <Col span={24}>
        <HeroDivider className="my-6" />
      </Col>
      <Row>
        <Col span={12}>
          <div className="title">{t("translation:reports")}</div>
        </Col>
        <Col span={12}>
          <div className="title">{reportCount}</div>
        </Col>
      </Row>
      <Col span={24}>
        <HeroDivider className="my-6" />
      </Col>
      <Row>
        <Col span={12}>
          <div className="title">{t("translation:snapshots")}</div>
        </Col>
        <Col span={12}>
          <div className="title">{snapshotCount}</div>
        </Col>
      </Row>
    </Box>
  );
}
